import { authConfig } from "../apiConfig";



export const get_worksite_with_out_pagination = async () => {
    try {
        const response = await authConfig.post(`getListWorksites`);
        return response.data;
    } catch (error) {
        throw error;
    }
};
export const get_worksite_with_pagination = async (data) => {
    try {
        const response = await authConfig.post(`getListWorksites`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response.data;
    } catch (error) {
        throw error;
    }
};
export const get_worksite_by_id = async (data) => {
    try {
        const response = await authConfig.post(`WorksiteViewById`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const worksite_creation = async (data) => {
    try {
        const response = await authConfig.post(`createWorksite`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response;
    } catch (error) {
        throw error;
    }
};

export const worksite_update = async (data) => {
    try {
        const response = await authConfig.post(`updateWorksite`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response;
    } catch (error) {
        throw error;
    }
};

export const get_worksite_history_with_out_pagination = async (data) => {
    try {
        const response = await authConfig.post(`getWorksiteHistory`, data);
        return response.data;
    } catch (error) {
        throw error;
    }
};
